import { Link } from 'react-router-dom';

const entries = [
  { label: '电影', desc: '最新上映 · 高分推荐', icon: 'ri-film-line', to: '/category/movie', tone: 'primary' },
  { label: '电视剧', desc: '热播剧集 · 追更不断', icon: 'ri-tv-2-line', to: '/category/tv', tone: 'accent' },
  { label: '综艺', desc: '真人秀 · 音乐竞技', icon: 'ri-mic-line', to: '/category/variety', tone: 'secondary' },
  { label: '悬疑专区', desc: '烧脑推理 一追到底', icon: 'ri-spy-line', to: '/category/movie?genre=%E6%82%AC%E7%96%91', tone: 'primary' },
  { label: '爱情专区', desc: '甜宠虐恋 心动瞬间', icon: 'ri-heart-3-line', to: '/category/movie?genre=%E7%88%B1%E6%83%85', tone: 'accent' },
  { label: '科幻专区', desc: '星际深海 未知想象', icon: 'ri-planet-line', to: '/category/movie?genre=%E7%A7%91%E5%B9%BB', tone: 'secondary' },
];

const toneMap: Record<string, string> = {
  primary: 'bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50',
  accent: 'bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-accent-950',
  secondary: 'bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50',
};

export default function CategoryQuick() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-5 md:mb-6">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wider text-accent-600 uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
            快速入口
          </span>
          <h2 className="mt-1.5 font-display text-2xl md:text-3xl font-bold text-foreground-950">按分类与题材探索</h2>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {entries.map((e) => (
          <Link
            key={e.label}
            to={e.to}
            className="group p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className={`w-11 h-11 rounded-md flex items-center justify-center transition-colors ${toneMap[e.tone]}`}>
              <i className={`${e.icon} text-xl`} />
            </span>
            <h3 className="mt-3.5 text-sm md:text-base font-semibold text-foreground-950">{e.label}</h3>
            <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{e.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}